import { useEffect, useState } from "react";
import { useTranslator } from "../../i18n/translator";
import { ContentParagraphs } from "./ContentText";
import { Countdown } from "./Countdown";
import { formatDeadlineDate, getDeadlineDate } from "./deadline";
import type { DeadlineContent } from "./frontpageContent";

export const CollectionDeadline = ({
  content,
}: {
  content: DeadlineContent;
}) => {
  const translator = useTranslator();
  const deadline = getDeadlineDate(content.date);
  const displayDate = formatDeadlineDate(deadline);
  const [now, setNow] = useState(() => new Date());
  const closed = now.getTime() >= deadline.getTime();

  useEffect(() => {
    if (closed) return;
    const timer = window.setInterval(() => setNow(new Date()), 1000);
    return () => window.clearInterval(timer);
  }, [closed]);

  return (
    <div className="hero-deadline" aria-live="polite">
      <h2 className="deadline-title">
        {closed ? content.closed.title : content.label}
      </h2>
      {closed ? (
        <div className="deadline-note">
          <ContentParagraphs paragraphs={content.closed.paragraphs} />
        </div>
      ) : (
        <>
          <div className="deadline-row">
            <span className="line-unit date-unit">
              <span className="line-num deadline-date">{displayDate}</span>
              <span className="cd-comma" aria-hidden="true">
                ,
              </span>
              <span className="line-label">EOD</span>
            </span>
            <span className="deadline-sep" aria-hidden="true" />
            <Countdown
              deadline={deadline}
              ariaLabel={translator("countdownAriaLabel", {
                deadline: `${displayDate}, EOD`,
              })}
              labels={{
                days: translator("countdownDays"),
                hours: translator("countdownHours"),
                minutes: translator("countdownMinutes"),
              }}
            />
          </div>
          {content.paragraphs.length > 0 && (
            <div className="deadline-note">
              <ContentParagraphs paragraphs={content.paragraphs} />
            </div>
          )}
        </>
      )}
    </div>
  );
};
